/**
 * Phase 4: shifts & cash, inventory. Each behaviour is a switch in
 * Settings → Shifts & inventory (defaults below are the recommended ones).
 */

/** Indian currency for the closing count (₹2000 is withdrawn from circulation but still legal tender). */
export const DENOMINATIONS = Object.freeze([2000, 500, 200, 100, 50, 20, 10, 5, 2, 1]);

export const DAY_CLOSE_MODES = Object.freeze([
  { key: 'remind', label: 'Remind managers, keep billing open' },
  { key: 'block', label: 'Block billing until the previous day is closed' },
]);

export const COSTING_METHODS = Object.freeze([
  { key: 'weighted_average', label: 'Weighted average cost' },
  { key: 'last_purchase', label: 'Last purchase price' },
]);

export const DEDUCT_ON = Object.freeze([
  { key: 'sale', label: 'When the sale is completed' },
  { key: 'kot', label: 'When items are sent to the kitchen (KOT)' },
]);

export const DEFAULT_CASH_OUT_CATEGORIES = Object.freeze([
  'Vegetables & groceries',
  'Supplies',
  'Transport',
  'Staff food',
  'Repairs',
  'Other',
]);

export const DEFAULT_OPERATIONS_SETTINGS = Object.freeze({
  // Every outlet runs its own shifts, one at a time (shift.service.js).
  shifts: Object.freeze({
    blindClose: true,
    requireOpenShift: true,
    dayClose: 'remind',
    emailZReport: true,
    cashOutCategories: DEFAULT_CASH_OUT_CATEGORIES,
  }),
  inventory: Object.freeze({
    allowNegativeStock: true,
    costing: 'weighted_average',
    deductOn: 'sale',
    restockOnRefund: true,
    separatePurchaseGst: true,
    lowStockEmail: true,
    expiryWarningDays: 3,
  }),
});

// ---------------------------------------------------------------- inventory
/** Stock is kept in base units (g, ml, pcs); other units convert by a factor. */
export const UNITS = Object.freeze({
  g: { base: 'g', factor: 1, label: 'g' },
  kg: { base: 'g', factor: 1000, label: 'kg' },
  ml: { base: 'ml', factor: 1, label: 'ml' },
  l: { base: 'ml', factor: 1000, label: 'L' },
  pcs: { base: 'pcs', factor: 1, label: 'pcs' },
  dozen: { base: 'pcs', factor: 12, label: 'dozen' },
});
export const BASE_UNITS = Object.freeze(['g', 'ml', 'pcs']);

export const STOCK_MOVE_TYPES = Object.freeze({
  opening: 'Opening stock',
  purchase: 'Goods received',
  sale: 'Used in sales',
  sale_reversal: 'Returned from sales',
  adjustment: 'Adjustment',
  wastage: 'Wastage',
  transfer_out: 'Transfer out',
  transfer_in: 'Transfer in',
  count: 'Stock count',
});

export const WASTAGE_REASONS = Object.freeze([
  'Expired',
  'Spoiled',
  'Spilled / damaged',
  'Over-production',
  'Staff meal',
  'Customer complaint',
  'Other',
]);

export const ADJUSTMENT_REASONS = Object.freeze(['Opening stock', 'Found extra', 'Missing', 'Correction', 'Other']);

export const STOCK_CATEGORY_SUGGESTIONS = Object.freeze([
  'Grains & pulses',
  'Vegetables',
  'Dairy',
  'Oils & fats',
  'Spices',
  'Beverages',
  'Packaging',
  'Other',
]);
